/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const SelectOrganizationBody = zod
	.object({
		organization_id: zod.uuid().describe('Organization ID to select')
	})
	.describe('Request body for selecting an organization');

export type SelectOrganizationBody = zod.input<typeof SelectOrganizationBody>;
export type SelectOrganizationBodyOutput = zod.output<typeof SelectOrganizationBody>;
